<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs6>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-layout>
                <v-flex class="mr-1" xs6>
                  <v-autocomplete
                    :loading="loading"
                    v-model="entity"
                    :items="reviewedEntities"
                    cache-items
                    :search-input.sync="searchTerm"
                    hide-details
                    return-object
                    item-text="title"
                    item-value="title"
                    placeholder="Select Entity"
                    no-data-text="Type a name of an entity to search"
                    outlined
                    chips
                    dense
                    @change="entitySelected"
                  ></v-autocomplete>
                </v-flex>
                <v-flex class="ml-1" xs6>
                  <v-select
                    outlined
                    dense
                    hide-details
                    return-object
                    :items="regionsWithAll"
                    v-model="selectedRegion"
                    item-text="name"
                    placeholder="Select Region"
                    @change="selectRegion"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex text-right>
              <v-btn @click="openNewCampaignDialog" depressed color="primary">
                Create New Campaign
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between class="mt-2">
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs3 text-right v-if="selectedRegion.name !== 'All'">
              <v-select
                hide-details
                outlined
                placeholder="Filter By Status"
                dense
                v-model="selectedState"
                @change="stateSelected"
                :items="[
                  'all',
                  'active',
                  'scheduled',
                  'updated',
                  'expired',
                  'deleted',
                ]"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="campaigns"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available, Select a region to start"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="copyItem(item)"> mdi-content-copy </v-icon>
        </template>
        <template v-slot:item.scheduledAt="{ item }">
          <div>
            {{ iMoment(item.scheduledAt) }}
          </div>
        </template>
        <template v-slot:item.pinData.data.image="{ item }">
          <div style="min-width: 50px">
            <v-icon small v-if="item.pinData.data.image">
              mdi-paperclip
            </v-icon>
          </div>
        </template>
        <template v-slot:item.pinData.pinType.name="{ item }">
          <div style="min-width: 80px">
            {{ item.pinData.pinType.name }}
          </div>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-campaign-dialog
      :selectedRegion="selectedRegion"
      :collection="collection"
      ref="newCampaignDialog"
    />
    <edit-campaign-dialog
      :selectedRegion="selectedRegion"
      :details="editedItem"
      :collection="collection"
      ref="editCampaignDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewCampaignDialog from '../components/NewCampaignDialog';
import EditCampaignDialog from '../components/EditCampaignDialog.vue';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
export default {
  components: { NewCampaignDialog, EditCampaignDialog },
  data() {
    return {
      selectedRegion: {},
      collection: 'campaigns',
      searchTerm: '',
      entity: null,
      selectedState: '',
      loading: false,
      search: '',
      dialogDelete: false,
      itemToDelete: {
        scheduledAt: '',
        state: '',

        data: {
          expiresAt: '',
          content: '',
          graphics: {
            entity: '',
            icon: {
              bgColor: '',
              color: '',
              name: '',
              type: '',
            },
          },
          image: {
            thumbnail: '',
            url: '',
          },
          isMarker: '',
          location: '',
          score: '',

          totalComments: '',
          type: '',
          views: '',
        },
      },
      headers: [
        {
          text: 'Content',
          align: 'start',
          sortable: true,
          value: 'pinData.data.content',
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },

        // { text: "Scheduled At", value: "pinDatascheduledAt" },

        { text: 'Photo', value: 'pinData.data.image' },
        { text: 'Pin Type', value: 'pinData.pinType.name' },
        { text: 'State', value: 'state' },
        { text: 'Frequency', value: 'repeatType' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedItem: {
        scheduledAt: '',
        state: '',
        data: {
          content: '',
          graphics: {
            entity: '',
            icon: {
              bgColor: '',
              color: '',
              name: '',
              type: '',
            },
          },
          image: {
            thumbnail: '',
            url: '',
          },
          isMarker: '',
          location: '',
          score: '',

          totalComments: '',
          type: '',
          views: '',
        },
      },
      editedIndex: -1,
      defaultItem: {
        scheduledAt: '',
        state: '',
        data: {
          content: '',
          graphics: {
            entity: '',
            icon: {
              bgColor: '',
              color: '',
              name: '',
              type: '',
            },
          },
          image: {
            thumbnail: '',
            url: '',
          },
          isMarker: '',
          location: '',
          score: '',

          totalComments: '',
          type: '',
          views: '',
        },
      },
    };
  },
  computed: {
    ...mapState('$_content', ['campaigns']),
    ...mapState('$_home', ['regions']),
    ...mapState('$_entity', ['reviewedEntities']),
    regionsWithAll() {
      var arr = [];
      arr.push({ name: 'All' });
      arr = arr.concat(this.regions);
      return arr;
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  created() {
    if (this.regions.length === 0) {
      this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    }
  },
  methods: {
    ...mapActions({
      getCampaigns: '$_content/getContent',
      getCampaignsByRegion: '$_content/getContentByRegion',
      getCampaignsByEntity: '$_content/getContentByEntity',
      getCampaignsByRegionByState: '$_content/getContentByRegionByState',
      getCampaignsByEntityByState: '$_content/getContentByEntityByState',
      deleteCampaign: '$_content/deleteContent',
      getRegions: '$_home/getContent',
      searchEntitiesAction: '$_entity/searchContent',
    }),
    searchEntities(searchTerm) {
      //this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    stateSelected(state) {
      this.selectedState = state;
      if (this.entity) {
        if (this.selectedState == 'all') {
          this.getCampaignsByEntity({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            entity: this.entity,
          });
        } else {
          this.getCampaignsByEntityByState({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            entity: this.entity,
            state: this.selectedState,
          });
        }
      } else if (this.selectedRegion) {
        if (this.selectedState == 'all') {
          this.getCampaignsByRegion({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
          });
        } else {
          this.getCampaignsByRegionByState({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
            state: this.selectedState,
          });
        }
      }
    },
    entitySelected(entity) {
      console.log(entity);
      if (this.selectedState === '') {
        this.selectedState = 'active';
      }
      this.selectedRegion = entity.region;
      if (this.selectedState === 'all') {
        console.log(entity);
        this.getCampaignsByEntity({
          type: 'campaign',
          collection: this.collection,
          mutation: 'updateCampaigns',
          entity: entity,
        });
      } else {
        this.getCampaignsByEntityByState({
          type: 'campaign',
          collection: this.collection,
          mutation: 'updateCampaigns',
          entity: entity,
          state: this.selectedState,
        });
      }
    },
    selectRegion() {
      // console.log("selectedRegion: ", this.selectedRegion);

      this.entity = null;
      if (this.selectedRegion.name === 'All') {
        this.loading = true;
        this.getCampaigns({
          type: 'campaign',
          collection: this.collection,
          mutation: 'updateCampaigns',
        }).then(() => {
          this.loading = false;
        });
      } else {
        if (this.selectedState === 'all') {
          this.getCampaignsByRegion({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
          });
        } else if (
          this.selectedState === 'active' ||
          this.selectedState === ''
        ) {
          console.log('Region: ', this.selectedRegion);
          if (this.selectedRegion.name !== 'All') {
            this.selectedState = 'active';
          }

          this.getCampaignsByRegionByState({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
            state: this.selectedState,
          });
        } else {
          this.getCampaignsByRegionByState({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
            state: this.selectedState,
          });
        }
      }
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    openNewCampaignDialog() {
      this.$refs.newCampaignDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.campaigns.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.campaigns[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editCampaignDialog.toggleDialog(this.editedItem);
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.campaigns.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.campaigns[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editCampaignDialog.toggleDialog(this.editedItem, 'copy');
    },
    deleteItem(item) {
      this.editedIndex = this.campaigns.indexOf(item);
      this.itemToDelete = Object.assign({}, this.campaigns[this.editedIndex]);
      this.itemToDelete.state = 'deleted';
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deleteCampaign({
        details: this.itemToDelete,
        collection: this.collection,
        type: 'Campaign',
      }).then(() => {
        this.dialogDelete = false;
        if (this.selectedRegion) {
          this.getCampaignsByRegion({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
          });
        }
      });
    },
  },
};
</script>

<style></style>
